export default "__VITE_ASSET__efa4c9dd__"